// Fallback value for empty data in MetricsGraph
export const EMPTY_VALUE = 'Unknown';
